import { render, staticRenderFns } from "./DatosTitular.vue?vue&type=template&id=8e88df04"
import script from "./DatosTitular.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosTitular.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports